












import { Vue, Component, Prop } from 'vue-property-decorator';
import { Area } from '@/http';
@Component({

})
export default class SAddress extends Vue  {
   // 级联数据
    public dataList = [];
    public cascaderData = null;
    public cityList = [];
    public countryList = [];
    public provinceCode:string = '';
    public cityCode:string = '';
    props = {
        // checkStrictly: true, //开启可以只选择一级
        value: "value",
        label: "text",
        lazy: true, // 此处必须为true
        lazyLoad: (node, resolve) => {
          if (node.data && node.data.text) {
            this.getChildData(node.data, resolve, node.level);
          }
        },
    }
    created(){
        this.getProvince();
    }
    public getChildData(data,resolve,level){
         if (level == 1) {
        //市
        this.provinceCode = data.value;
        this.getCityList(this.provinceCode, resolve);
      } else if (level == 2) {
        //区
        this.cityCode = data.value;
        this.getCountyList(this.cityCode, resolve);
      }
    }
    handleChange(val){
      if(val.length > 0){
        this.$emit('getSAddressData',this.cascaderData)
      }
    }
    // 获取省
    async getProvince() {
        let area = await Area.area();
        this.dataList = area.data;
    }
    // 获取市
    async getCityList(code,resolve) {
        let city = await Area.city(code);
        this.cityList = city.data;
        resolve(this.cityList);
    }
    // 获取区
    async getCountyList(code,resolve) {
        let County = await Area.county(code);
        County.data.forEach((item)=>{
            item.leaf = true;
        })
        this.countryList = County.data;
        resolve(this.countryList);
    }
}
